import { RETRIEVE_ALL_USERS } from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

export function retrieveAllUsers() {
  return dispatch => {
    const url = `${apiEndPoints.userManagement.GET_ALL_USERS}`;
    const promise = new Promise((resolve, reject) => {
      const doRequest = http.get(url);
      doRequest.then(
        res => {
          dispatch({
            type: RETRIEVE_ALL_USERS,
            data: res.data.data,
          });
          resolve(res);
        },
        err => {
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  if (action.type === RETRIEVE_ALL_USERS) {
    return {
      ...state,
      accounts: [...action.data],
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/features/user-management/redux/retrieveAllUsers.js